<template>
  <div v-if="user" class="min-h-screen bg-gray-100">
    <SidebarMenu :user="user" :isMenuOpen="isMenuOpen" @toggle-menu="toggleMenu" @close-menu="closeMenu"
      @logout="logout" />

    <div class="md:ml-64">
      <main class="p-4">
        <div class="p-4">
          <h1 class="text-xl font-bold mb-6">Perfil / Datos Generales</h1>

          <div v-if="loading" class="flex justify-center my-8">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>

          <div class="mb-6 bg-yellow-50 border border-yellow-200 text-yellow-700 px-4 py-3 rounded">
            Estimado alumno, si algún campo marcado con
            ( <span class="inline-flex items-center">
              <svg class="w-5 h-5 text-gray-500 align-middle" fill="none" stroke="currentColor" stroke-width="1.5"
                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M1.5 12S4.5 4.5 12 4.5 22.5 12 22.5 12s-3 7.5-10.5 7.5S1.5 12 1.5 12z"></path>
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 15.75A3.75 3.75 0 1 0 12 8.25a3.75 3.75 0 0 0 0 7.5z"></path>
              </svg>
            </span> )
            se encuentra vacío o equivocado, dirígete al departamento de escolares de tu campus para solicitar una actualización.
          </div>

          <div>

            <form @submit.prevent="updateProfile" class="mt-6">
              <!-- Información general -->
              <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white p-6 mb-6">
                <h2 class="text-lg font-semibold mb-4">Información general</h2>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label class="flex text-sm font-medium text-gray-500">
                      <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" stroke-width="1.5"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M1.5 12S4.5 4.5 12 4.5 22.5 12 22.5 12s-3 7.5-10.5 7.5S1.5 12 1.5 12z"></path>
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M12 15.75A3.75 3.75 0 1 0 12 8.25a3.75 3.75 0 0 0 0 7.5z"></path>
                      </svg>
                      Nombre</label>
                    <input type="text" :value="user.name" disabled
                      class="mt-1 block w-full rounded-md border-gray-300 bg-gray-100 shadow-sm" />
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-500">Correo Institucional</label>
                    <input type="email" :value="user.email" disabled
                      class="mt-1 block w-full rounded-md border-gray-300 bg-gray-100 shadow-sm" />
                  </div>

                  <div>
                    <label for="curp" class="flex text-sm font-medium text-gray-500">
                      <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" stroke-width="1.5"
                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M1.5 12S4.5 4.5 12 4.5 22.5 12 22.5 12s-3 7.5-10.5 7.5S1.5 12 1.5 12z"></path>
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M12 15.75A3.75 3.75 0 1 0 12 8.25a3.75 3.75 0 0 0 0 7.5z"></path>
                      </svg>
                      CURP</label>
                    <input id="curp" :value="studentData.CURP" disabled
                      class="mt-1 block w-full rounded-md border-gray-300 bg-gray-100 shadow-sm" />
                  </div>

                  <div>
                    <label for="birthDate" class="block text-sm font-medium text-gray-500">Fecha de Nacimiento*</label>
                    <input id="birthDate" v-model="formData.BirthDate" type="date" :max="minBirthDate" required
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" />
                  </div>


                </div>
              </div>


              <!-- Domicilio -->
              <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white p-6 mb-6">
                <h2 class="text-lg font-semibold mb-4">Domicilio</h2>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label for="state" class="block text-sm font-medium text-gray-500">Estado*</label>
                    <select id="state" v-model="formData.StateId" @change="loadCities" required
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
                      <option value="">Seleccionar Estado</option>
                      <option v-for="state in states" :key="state.StateId" :value="state.StateId">
                        {{ state.State }}
                      </option>
                    </select>
                  </div>

                  <div>
                    <label for="city" class="block text-sm font-medium text-gray-500">Ciudad*</label>
                    <select id="city" v-model="formData.CityId" @change="loadColonies" :disabled="!formData.StateId"
                      required
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
                      <option value="">Seleccionar Ciudad</option>
                      <option v-for="city in cities" :key="city.CityId" :value="city.CityId">
                        {{ city.City }}
                      </option>
                    </select>
                  </div>

                  <div>
                    <label for="colony" class="block text-sm font-medium text-gray-500">Colonia*</label>
                    <select id="colony" v-model="formData.ColonyId" :disabled="!formData.CityId" required
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
                      <option value="">Seleccionar Colonia</option>
                      <option v-for="colony in colonies" :key="colony.ColonyId" :value="colony.ColonyId">
                        {{ colony.Colony }}
                      </option>
                    </select>
                  </div>

                  <div>
                    <label for="street" class="block text-sm font-medium text-gray-500">Calle y número*</label>
                    <input id="street" v-model="formData.Street" type="text" required
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" />
                  </div>

                  <div>
                    <label for="postalCode" class="block text-sm font-medium text-gray-500">Código Postal</label>
                    <input id="postalCode" :value="studentData.PostalCode" disabled
                      class="mt-1 block w-full rounded-md border-gray-300 bg-gray-100 shadow-sm" />
                  </div>
                </div>
              </div>

              <!-- Contacto -->
              <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white p-6 mb-6">
                <h2 class="text-lg font-semibold mb-4">Contacto</h2>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label for="personalEmail" class="block text-sm font-medium text-gray-500">Correo Personal*</label>
                    <input id="personalEmail" v-model="formData.PersonalEmail" type="email" required
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" />
                  </div>

                  <div>
                    <label for="phone" class="block text-sm font-medium text-gray-500">Teléfono*</label>
                    <input id="phone" v-model="formData.Phone" type="tel" minlength="7" maxlength="10" required
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" />
                  </div>

                  <div>
                    <label for="cellphone" class="block text-sm font-medium text-gray-500">Celular*</label>
                    <input id="cellphone" v-model="formData.Cellphone" type="tel" minlength="10" maxlength="10" required
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" />
                  </div>
                </div>
              </div>
              <div class="flex flex-col sm:flex-row gap-3 justify-end mt-6">
                <button type="button"
                  class="hidden inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  @click="resetForm">
                  <svg class="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" stroke-width="2"
                    viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Cancelar
                </button>
                <button type="submit"
                  class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  :disabled="loading">
                  <svg v-if="!loading" class="w-4 h-4 mr-2 text-white" fill="none" stroke="currentColor"
                    stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7" />
                  </svg>
                  {{ loading ? 'Actualizando...' : 'Actualizar Perfil' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SidebarMenu from '@/components/SidebarMenu.vue';
import { 
  getStudentData, 
  updateStudentData, 
  getStates, 
  getCities, 
  getColonies,
  clearAuthToken 
} from '@/services/api';

export default {
  components: {
    SidebarMenu
  },
  data() {
    return {
      user: null,
      studentData: {},
      isMenuOpen: false,
      loading: false,
      successMessage: null,
      states: [],
      cities: [],
      colonies: [],
      formData: {
        BirthDate: '',
        StateId: '',
        CityId: '',
        ColonyId: '',
        Street: '',
        PersonalEmail: '',
        Phone: '',
        Cellphone: ''
      }
    };
  },
  computed: {
    minBirthDate() {
      const today = new Date();
      const tenYearsAgo = new Date(
        today.getFullYear() - 10,
        today.getMonth(),
        today.getDate()
      );
      return tenYearsAgo.toISOString().split('T')[0];
    }
  },
  async created() {
    await this.getUserFromBackend();
    if (this.user) {
      await this.loadStudentData();
      await this.loadStates();
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return new Date(dateString).toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    async getUserFromBackend() {
      try {
        const response = await axios.get('/me');
        this.user = response.data.user;
      } catch (error) {
        console.error("Error obteniendo usuario", error);
        this.$router.push('/login');
      }
    },
    async loadStudentData() {
      try {
        this.loading = true;
        const studentId = this.user.email.match(/^a(\d+)@/)[1];
        
        // Usar función del api.js con Bearer Token
        const response = await getStudentData(studentId);
        this.studentData = response.data[0];

        // Prepopulate form data
        this.formData = {
          BirthDate: this.studentData.BirthDate.split('T')[0],
          StateId: this.studentData.StateId,
          CityId: this.studentData.CityId,
          ColonyId: this.studentData.ColonyId,
          Street: this.studentData.Street,
          PersonalEmail: this.studentData.PersonalEmail,
          Phone: this.studentData.Phone,
          Cellphone: this.studentData.Cellphone
        };

        await this.loadCities();
        await this.loadColonies();
      } catch (error) {
        console.error('Error al cargar datos del estudiante:', error);

        this.loading = false;
        await this.$alert(
            'Error',
            'No se pudieron cargar los datos del estudiante.',
            'error'
          );

      } finally {
        this.loading = false;
      }
    },
    async loadStates() {
      try {
        // Usar función del api.js con Bearer Token
        const response = await getStates(1);
        this.states = response.data || [];
      } catch (error) {
        console.error('Error al cargar estados:', error);
      }
    },
    async loadCities() {
      if (!this.formData.StateId) return;

      try {
        // Usar función del api.js con Bearer Token
        const response = await getCities(this.formData.StateId);
        this.cities = response.data || [];
        this.colonies = [];
      } catch (error) {
        console.error('Error al cargar ciudades:', error);
      }
    },
    async loadColonies() {
      if (!this.formData.CityId) return;

      try {
        // Usar función del api.js con Bearer Token
        const response = await getColonies(this.formData.CityId);
        this.colonies = response.data || [];
      } catch (error) {
        console.error('Error al cargar colonias:', error);
      }
    },
    async updateProfile() {
      try {
        this.loading = true;

        // Validación de teléfonos
        if (this.formData.Phone.length < 7 || this.formData.Phone.length > 10) {
          throw new Error('El teléfono debe tener entre 7 y 10 dígitos');
        }
        if (this.formData.Cellphone.length !== 10) {
          throw new Error('El celular debe tener 10 dígitos');
        }

        const studentId = this.user.email.match(/^a(\d+)@/)[1];

        // Usar función del api.js con Bearer Token
        const response = await updateStudentData(studentId, this.formData);
        console.log(response);

        this.loading = false;
        await this.$alert(
            'Datos actualizados exitosamente',
            '',
            'success'
          );

      } catch (error) {
        this.loading = false;
        console.error('Error al actualizar perfil:', error);

        await this.$alert(
            'Error al actualizar perfil',
            'Por favor, intente más tarde.',
            'error'
          );

      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      // Restaurar datos originales
      this.formData = {
        BirthDate: this.studentData.BirthDate.split('T')[0],
        StateId: this.studentData.StateId,
        CityId: this.studentData.CityId,
        ColonyId: this.studentData.ColonyId,
        Street: this.studentData.Street,
        PersonalEmail: this.studentData.PersonalEmail,
        Phone: this.studentData.Phone,
        Cellphone: this.studentData.Cellphone
      };
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    async logout() {
      try {
        // Limpiar el token Bearer antes del logout
        clearAuthToken();
        
        // Obtener nuevo token CSRF
        await axios.get('/sanctum/csrf-cookie');

        // Esperar un momento para asegurar que la cookie se haya establecido
        await new Promise(resolve => setTimeout(resolve, 100));

        // Realizar la petición de logout
        const response = await axios.post('/logout', {}, {
          withCredentials: true,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });
        console.log(response);
        
        // Limpiar cookies locales
        document.cookie.split(";").forEach(function (c) {
          document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });

        // Redirigir al login
        this.$router.push('/login');
      } catch (error) {
        console.error('Error al cerrar sesión:', error.response?.data || error);
      }
    }
  }
};
</script>